"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useFeatureFlag = exports.useConfig = exports.styledFeatureFlag = exports.default = exports.FeatureFlagProvider = exports.ConfigProvider = exports.ConfigContext = void 0;
var _react = require("react");
var _styledComponents = require("styled-components");
var _jsxRuntime = require("react/jsx-runtime");
const ConfigContext = exports.ConfigContext = /*#__PURE__*/(0, _react.createContext)({});

/** Temporarily changed to any to support passing functions through */
const useConfig = function () {
  const envData = (0, _react.useContext)(ConfigContext);
  return envData;
};
exports.useConfig = useConfig;
const ConfigProvider = function (_ref) {
  let {
    children,
    ...props
  } = _ref;
  const envData = useConfig();
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(ConfigContext.Provider, {
    value: {
      ...envData,
      ...props
    },
    "data-testid": "ConfigProvider",
    children: children
  });
};
exports.ConfigProvider = ConfigProvider;
const FeatureFlagProvider = function (props) {
  const {
    children,
    value = {}
  } = props;
  const parentValues = useConfig();
  const consolidatedValues = {
    ...parentValues,
    ...value
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styledComponents.ThemeProvider, {
    theme: {
      flags: consolidatedValues
    },
    "data-testid": "FeatureFlagProvider",
    children: children
  });
};
exports.FeatureFlagProvider = FeatureFlagProvider;
const typeMap = {
  true: true,
  false: false,
  undefined: undefined,
  null: null
};
const typeMapKeys = Object.keys(typeMap);

/**
 * TODO: reconsider how this works. Devs can pass in any value and we might get
 * unexpected results from default JS number coercion
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number#number_coercion
 */
const castType = function (maybeString) {
  if (typeof maybeString !== "string") {
    return Number.isNaN(Number(maybeString)) ? maybeString : Number(maybeString);
  }
  if (typeMapKeys.includes(maybeString)) return typeMap[maybeString];
  return Number.isNaN(Number(maybeString)) ? maybeString : Number(maybeString);
};
const styledFeatureFlag = function (flag, css, fallbackCSS) {
  return function (_ref2) {
    var _theme$flags;
    let {
      theme
    } = _ref2;
    return castType(theme === null || theme === void 0 ? void 0 : (_theme$flags = theme.flags) === null || _theme$flags === void 0 ? void 0 : _theme$flags[flag]) ? css : fallbackCSS;
  };
};
exports.styledFeatureFlag = styledFeatureFlag;
const useFeatureFlag = function (flag) {
  const flags = useConfig();
  if (typeof flag === "undefined") return flags;
  return castType(flags === null || flags === void 0 ? void 0 : flags[flag]);
};
exports.useFeatureFlag = useFeatureFlag;
var _default = exports.default = useFeatureFlag;